import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SortableTable } from './services-table-helper';

@Injectable({
  providedIn: 'root'
})
export class AdeverintaApiaService extends SortableTable<any> {
  private baseUrl = environment.API_URL;

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  listAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/adeverinta-apia/list/`,
      req_params
    ).pipe(
        map((response: any) => {
          this.totalRecords = response.count;
          this.paginate();

          return response;
        }));
  }

  dateAdeverintaAPI(id) {
    return this.http.get(
      `${this.baseUrl}/documente/adeverinta-apia/${id}`).pipe(
        map((response: any) => {
          return response;
        }));
  }

  exploatatiiAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/adeverinta-apia/exploatatii/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        }));
  }

  animaleAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/adeverinta-apia/animale/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  creazaAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/adeverinta-apia/creaza/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  salveazaAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/adeverinta-apia/salveaza/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  salveazaNrDataAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/adeverinta-apia/salveaza-nr-data/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  finalizeazaAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/adeverinta-apia/finalizeaza/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  anuleazaAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/adeverinta-apia/anuleaza/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  stergeAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/adeverinta-apia/sterge/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  descarcaAPI(id) {
    return this.http.get(
      `${this.baseUrl}/documente/adeverinta-apia/descarca/${id}`,
        {
          responseType: 'blob'
        }
      ).pipe(
        map((response: any) => {
          return response;
      }));
  }

  exportAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/adeverinta-apia/export/`,
        req_params,
        {
          responseType: 'blob'
        }
      ).pipe(
        map((response: any) => {
          return response;
      }));
  }

  private paginate(): void {
    this._state.startIndex = (this._state.page - 1) * this.pageSize + 1;
    this._state.endIndex = Number(this.pageSize) + Number(this._state.startIndex - 1);

    if (this._state.endIndex > this.totalRecords) {
      this._state.endIndex = this.totalRecords;
    }
  }
}
